import { render, staticRenderFns } from "./shippingCharges.vue?vue&type=template&id=a3aef710&scoped=true&"
import script from "./shippingCharges.vue?vue&type=script&lang=js&"
export * from "./shippingCharges.vue?vue&type=script&lang=js&"
import style0 from "./shippingCharges.vue?vue&type=style&index=0&id=a3aef710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3aef710",
  null
  
)

export default component.exports